import React, { Component } from "react";
import moment from "moment";
import { NepaliDatePicker } from "nepali-calander";

class SubjectListTableRow extends Component {
  getTimeFromDate = (value) => {
  const m = moment(value, moment.ISO_8601, true);
  return m.isValid() && value.includes(":")
    ? m.format("HH:mm")
    : "";
};
  render() {
    return (
      <React.Fragment>
        <tr
          key={this.props.unKey}
          id={`${this.props.idx}${this.props.classroomId}`}
        >
          <td
            style={{ verticalAlign: "middle" }}
            rowSpan={
              this.props.subject.hasPractical && this.props.subject.hasTheory
                ? 2
                : 1
            }
          >
            <input
              type="checkbox"
              name="selectCheckbox"
              checked={this.props.subject.isChecked}
              onClick={(e) =>
                this.props.handleSelectRowCheckBoxClick(
                  e,
                  this.props.subject.subjectId,
                  this.props.classroomId,
                  this.props.yearLevelIndex,
                  this.props.classroomIndex,
                  this.props.subjectIndex
                )
              }
            />
          </td>

          <td
            style={{ verticalAlign: "middle" }}
            rowSpan={
              this.props.subject.hasPractical && this.props.subject.hasTheory
                ? 2
                : 1
            }
          >
            {this.props.subject.subjectName}
          </td>

          {this.props.subject.hasTheory ? (
            <>
              <td rowSpan={1}>Theory</td>

              <td style={{ display: "flex", alignItems: "center" }} rowSpan={1}>
                <NepaliDatePicker
                  type="input"
                  calendarMode={localStorage.getItem('calendar-mode')}
                  showToggle={true}
                  showNationalHoliday={false}
                  events={[]}
                  onDateSelect={(date) => {
                    this.props.handleChange(
                      {
                        target: { value: date.ad.date, name: "assessmentDateFromTheory" },
                      },
                      this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "assessmentFromDateTheory",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                    )
                  }
                  }
                  value={this.props.subject.assessmentFromDateTheory}
                />
                <input 
               type="time"
                className="form-control"
                name="assessmentFromTimeTheory"
                onChange={e => this.props.handleChange(
                  e,
                      this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "assessmentFromTimeTheory",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                )}
                disabled={
                    !this.props.subject.assessmentFromDateTheory
                  }
                  
                  // value={ !!this.props.subject.assessmentFromDateTheory && moment(this.props.subject.assessmentFromDateTheory).format("HH:mm:ss")}
                  value={this.getTimeFromDate(this.props.subject.assessmentFromDateTheory)}
                  defaultValue={""}
                />
                <span style={{ marginLeft: "5px", marginRight: "5px" }}>-</span>
                <NepaliDatePicker
                  type="input"
                  calendarMode={localStorage.getItem('calendar-mode')}
                  showToggle={true}
                  showNationalHoliday={false}
                  events={[]}
                  onDateSelect={(date) => {
                    this.props.handleChange(
                      {
                        target: { value: date.ad.date, name: "assessmentToDateTheory" },
                      },
                      this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "assessmentToDateTheory",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                    )
                  }
                  }
                  value={this.props.subject.assessmentToDateTheory}
                  minDate={moment(this.props.subject.assessmentFromDateTheory).format("YYYY-MM-DD")}
                  disabled={
                    !this.props.subject.assessmentFromDateTheory
                  }
                /> 
                <input 
               type="time"
                className="form-control"
                name="assessmentToTimeTheory"
                onChange={e => this.props.handleChange(
                  e,
                      this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "assessmentToTimeTheory",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                )}
                disabled={
                    !this.props.subject.assessmentToDateTheory
                  }
                  //  value={ !!this.props.subject.assessmentToDateTheory && moment(this.props.subject.assessmentToDateTheory).format("HH:mm:ss")}
                   value={ this.getTimeFromDate(this.props.subject.assessmentToDateTheory)}
                   defaultValue={""}
                />
              </td>
              <td rowSpan={1}>
                <NepaliDatePicker
                  type="input"
                  calendarMode={localStorage.getItem('calendar-mode')}
                  showToggle={true}
                  showNationalHoliday={false}
                  events={[]}
                  onDateSelect={(date) => {
                    this.props.handleChange(
                      {
                        target: { value: date.ad.date, name: "recordingDateTheory" },
                      },
                       this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "recordingDateTheory",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                    )
                  }
                  }
                  value={
                    this.props.subject.recordingDateTheory
                  }
                  minDate={moment(new Date()).format("YYYY-MM-DD")}
                />
              </td>
                  
              <td rowSpan={1}>
                <NepaliDatePicker
                  type="input"
                  calendarMode={localStorage.getItem('calendar-mode')}
                  showToggle={true}
                  showNationalHoliday={false}
                  events={[]}
                  onDateSelect={(date) => {
                    this.props.handleChange(
                      {
                        target: { value: date.ad.date, name: "recordingDeadlineTheory" },
                      },
                       this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "recordingDeadlineTheory",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                    )
                  }
                  }
                  value={
                    this.props.subject.recordingDeadlineTheory
                  }
                  minDate={moment(this.props.subject.recordingDateTheory).format("YYYY-MM-DD")}
                  disabled={
                    !this.props.subject.recordingDateTheory}
                />
              </td>
            </>
          ) : this.props.subject.hasPractical ? (
            <>
              <td rowSpan={1}>Practical</td>
              <td style={{ display: "flex", alignItems: "center" }} rowSpan={1}>
                 <NepaliDatePicker
                  type="input"
                  calendarMode={localStorage.getItem('calendar-mode')}
                  showToggle={true}
                  showNationalHoliday={false}
                  events={[]}
                  onDateSelect={(date) => {
                    this.props.handleChange(
                      {
                        target: { value: date.ad.date, name: "assessmentFromDatePractical" },
                      },
                      this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "assessmentFromDatePractical",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                    )
                  }
                  }
                   value={this.props.subject.assessmentFromDatePractical}
                  minDate={moment(this.props.minStartDate).format("YYYY-MM-DD")}
                /> 
                <input 
               type="time"
                className="form-control"
                name="assessmentFromTimePractical"
                onChange={e => this.props.handleChange(
                  e,
                      this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "assessmentFromTimePractical",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                )}
                disabled={
                    !this.props.subject.assessmentFromDatePractical
                  }
                  value={this.getTimeFromDate(this.props.subject.assessmentFromDatePractical)}
                  defaultValue={""}
                />
                <span style={{ marginLeft: "5px", marginRight: "5px" }}>-</span>
                  <NepaliDatePicker
                    type="input"
                    calendarMode={localStorage.getItem('calendar-mode')}
                    showToggle={true}
                    showNationalHoliday={false}
                    events={[]}
                    onDateSelect={(date) => {
                      this.props.handleChange(
                        {
                          target: { value: date.ad.date, name: "assessmentToDatePractical" },
                        },
                        this.props.idx,
                        this.props.yearLevel,
                        this.props.classroomId,
                        "assessmentToDatePractical",
                        this.props.yearLevelIndex,
                        this.props.classroomIndex,
                        this.props.subjectIndex
                      )
                    }
                    }
                     value={this.props.subject.assessmentToDatePractical}
                    minDate={moment(this.props.subject.assessmentFromDatePractical).format("YYYY-MM-DD")}
                    disabled={
                      !this.props.subject.assessmentFromDatePractical
                    }
                  /> 
                  <input
                   type="time"
                    className="form-control"
                    name="assessmentToTimePractical"
                    onChange={e => this.props.handleChange(
                      e,
                      this.props.idx,
                      this.props.yearLevel,
                      this.props.classroomId,
                      "assessmentToTimePractical",
                      this.props.yearLevelIndex,
                      this.props.classroomIndex,
                      this.props.subjectIndex
                    )} 
                    disabled={
                    !this.props.subject.assessmentToDatePractical
                  }
                  value={this.getTimeFromDate(this.props.subject.assessmentToDatePractical)}
                  defaultValue={""}
                    />
              </td>
              <td rowSpan={1}>
                  <NepaliDatePicker
                    type="input"
                    calendarMode={localStorage.getItem('calendar-mode')}
                    showToggle={true}
                    showNationalHoliday={false}
                    events={[]}
                    onDateSelect={(date) => {
                      this.props.handleChange(
                        {
                          target: { value: date.ad.date, name: "recordingDatePractical" },
                        },
                        this.props.idx,
                        this.props.yearLevel,
                        this.props.classroomId,
                        "recordingDatePractical",
                        this.props.yearLevelIndex,
                        this.props.classroomIndex,
                        this.props.subjectIndex
                      )
                    }
                    }
                    value={
                      this.props.subject.recordingDatePractical
                        ? this.props.subject.recordingDatePractical
                        : ""
                    }
                    minDate={moment(new Date()).format("YYYY-MM-DD")}
                  /> 
              </td>

              <td rowSpan={1}>
                  <NepaliDatePicker
                    type="input"
                    calendarMode={localStorage.getItem('calendar-mode')}
                    showToggle={true}
                    showNationalHoliday={false}
                    events={[]}
                    onDateSelect={(date) => {
                      this.props.handleChange(
                        {
                          target: { value: date.ad.date, name: "recordingDeadlinePractical" },
                        },
                        this.props.idx,
                        this.props.yearLevel,
                        this.props.classroomId,
                        "recordingDeadlinePractical",
                        this.props.yearLevelIndex,
                        this.props.classroomIndex,
                        this.props.subjectIndex
                      )
                    }
                    }
                    value={
                      this.props.subject.recordingDeadlinePractical
                        ? this.props.subject.recordingDeadlinePractical
                        : ""
                    }
                    minDate={moment(this.props.subject.recordingDatePractical).format("YYYY-MM-DD")}
                    disabled={
                      !this.props.subject.recordingDatePractical
                    }
                  /> 
              </td>
            </>
          ) : null}
        </tr>

        {this.props.subject.hasPractical && this.props.subject.hasTheory ? (
          <tr>
            {this.props.subject.hasPractical !== null &&
            this.props.subject.hasPractical ? (
              <>
                <td rowSpan={1}>Practical</td>
                <td
                  style={{ display: "flex", alignItems: "center" }}
                  rowSpan={1}
                >
                    <NepaliDatePicker
                      type="input"
                      calendarMode={localStorage.getItem('calendar-mode')}
                      showToggle={true}
                      showNationalHoliday={false}
                      events={[]}
                      onDateSelect={(date) => {
                        this.props.handleChange(
                          {
                            target: { value: date.ad.date, name: "assessmentFromDatePractical" },
                          },
                          this.props.idx,
                          this.props.yearLevel,
                          this.props.classroomId,
                          "assessmentFromDatePractical",
                          this.props.yearLevelIndex,
                          this.props.classroomIndex,
                          this.props.subjectIndex
                        )
                      }
                      }
                      value={this.props.subject.assessmentFromDatePractical}
                      minDate={moment(this.props.minStartDate).format("YYYY-MM-DD")}
                    /> 
                    <input
                     type="time"
                      className="form-control"
                      name="assessmentFromTimePractical"
                      onChange={e => this.props.handleChange(
                        e,
                        this.props.idx,
                        this.props.yearLevel,
                        this.props.classroomId,
                        "assessmentFromTimePractical",
                        this.props.yearLevelIndex,
                        this.props.classroomIndex,
                        this.props.subjectIndex
                      )} 
                      disabled={
                        !this.props.subject.assessmentFromDatePractical
                      }
                      value={this.getTimeFromDate(this.props.subject.assessmentFromDatePractical)}
                      defaultValue={""}
                      />
                  <span style={{ marginLeft: "5px", marginRight: "5px" }}>
                    -
                  </span>
                    <NepaliDatePicker
                      type="input"
                      calendarMode={localStorage.getItem('calendar-mode')}
                      showToggle={true}
                      showNationalHoliday={false}
                      events={[]}
                      onDateSelect={(date) => {
                        this.props.handleChange(
                          {
                            target: { value: date.ad.date, name: "assessmentToDatePractical" },
                          },
                          this.props.idx,
                          this.props.yearLevel,
                          this.props.classroomId,
                          "assessmentToDatePractical",
                          this.props.yearLevelIndex,
                          this.props.classroomIndex,
                          this.props.subjectIndex
                        )
                      }
                      }
                      value={
                        this.props.subject.assessmentToDatePractical
                      }
                      minDate={moment(this.props.subject.assessmentFromDatePractical).format("YYYY-MM-DD")}
                      disabled={
                        !this.props.subject.assessmentFromDatePractical
                      }
                    /> 
                    <input
                     type="time"


                      className="form-control"
                      name="assessmentToTimePractical"
                      onChange={e => this.props.handleChange(
                        e,
                        this.props.idx,
                        this.props.yearLevel,
                        this.props.classroomId,
                        "assessmentToTimePractical",
                        this.props.yearLevelIndex,
                        this.props.classroomIndex,
                        this.props.subjectIndex
                      )} 
                       disabled={
                        !this.props.subject.assessmentToDatePractical
                      }
                      value={this.getTimeFromDate(this.props.subject.assessmentToDatePractical)}
                      defaultValue={""}
                      />
                </td>
                <td rowSpan={1}>
                    <NepaliDatePicker
                      type="input"
                      calendarMode={localStorage.getItem('calendar-mode')}
                      showToggle={true}
                      showNationalHoliday={false}
                      events={[]}
                      onDateSelect={(date) => {
                        this.props.handleChange(
                          {
                            target: { value: date.ad.date, name: "recordingDatePractical" },
                          },
                          this.props.idx,
                          this.props.yearLevel,
                          this.props.classroomId,
                          "recordingDatePractical",
                          this.props.yearLevelIndex,
                          this.props.classroomIndex,
                          this.props.subjectIndex
                        )
                      }
                      }
                      value={
                        this.props.subject.recordingDatePractical
                          ? this.props.subject.recordingDatePractical
                          : ""
                      }
                      minDate={moment(new Date()).format("YYYY-MM-DD")}
                    /> 
                </td>

                <td rowSpan={1}>
                    <NepaliDatePicker
                      type="input"
                      calendarMode={localStorage.getItem('calendar-mode')}
                      showToggle={true}
                      showNationalHoliday={false}
                      events={[]}
                      onDateSelect={(date) => {
                        this.props.handleChange(
                          {
                            target: { value: date.ad.date, name: "recordingDeadlinePractical" },
                          },
                          this.props.idx,
                          this.props.yearLevel,
                          this.props.classroomId,
                          "recordingDeadlinePractical",
                          this.props.yearLevelIndex,
                          this.props.classroomIndex,
                          this.props.subjectIndex
                        )
                      }
                      }
                      value={
                        this.props.subject.recordingDeadlinePractical
                          ? this.props.subject.recordingDeadlinePractical
                          : ""
                      }
                      minDate={moment(this.props.subject.recordingDatePractical).format("YYYY-MM-DD")}
                      disabled={
                        !this.props.subject.recordingDatePractical
                      }
                    /> 
                </td>
              </>
            ) : null}
          </tr>
        ) : null}
      </React.Fragment>
    );
  }
}

export default SubjectListTableRow;
